const sizes = {
  mobile: "max-width: 1040px",
};

export default sizes;
